import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { UserModuleConsts } from '../../constants';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss'],
    standalone: false
})

export class ThankYouComponent implements OnInit {
  forgot_email: any;

  constructor(
    private titleService: Title,
    private statePersistService: StatePersistService
  ) { }

  ngOnInit() {
    this.forgot_email = this.statePersistService.getLocalStorage('forgot_email');
    this.titleService.setTitle(UserModuleConsts.THANKU_PAGE_TITLE);
  }
}
